import { render, staticRenderFns } from "./PanelMenuButton.vue?vue&type=template&id=25cae3d6&scoped=true&"
import script from "./PanelMenuButton.vue?vue&type=script&lang=js&"
export * from "./PanelMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./PanelMenuButton.vue?vue&type=style&index=0&id=25cae3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cae3d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cae3d6')) {
      api.createRecord('25cae3d6', component.options)
    } else {
      api.reload('25cae3d6', component.options)
    }
    module.hot.accept("./PanelMenuButton.vue?vue&type=template&id=25cae3d6&scoped=true&", function () {
      api.rerender('25cae3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelMenuButton.vue"
export default component.exports